import {
  type OfferV11,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

export const productAccessorGetBestSellerPromotionFromOffer = (
  currentOffer: OfferV11 | undefined,
): SellerPromotionV2 | undefined => {
  if (!currentOffer) {
    return undefined
  }

  const sellerPromotions = currentOffer.sellerPromotions ?? []

  return sellerPromotions.find((promotion) => promotion.bestPromotion)
}
